import React from "react";
import jwtClient from "../JwtClient";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import DateUtils from "../DateUtils";
import {Link} from "react-router-dom";
import {withFormik} from "formik";
import FormGroup from "react-bootstrap/FormGroup";
import InputGroup from "react-bootstrap/InputGroup";
import {FormControl} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


function SearchFormInner(props) {
    const {
        values,
        handleChange,
        handleSubmit,
    } = props;
    return (
        <FormGroup className="ml-auto mt-4">
            <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text>
                        <FontAwesomeIcon icon="search"/>
                    </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    name="track"
                    value={values.track}
                    onChange={handleChange}
                    onKeyPress={e => {
                        if (e.key === 'Enter') {
                            handleSubmit(e);
                        }
                    }}
                    placeholder="Reference/order number"
                />
            </InputGroup>
        </FormGroup>
    )
}

const SearchForm = withFormik({
    mapPropsToValues: () => ({
        track: '',
    }),
    handleSubmit: (values, formikBag) => {
        formikBag.props.loadPackages(`/api/v1/package/list?q=${values.track}`);
    },
})(SearchFormInner);

export default class PackageList extends React.Component {
    state = {
        packages: [],
        total: 0,
        next: '',
        previous: '',
        error: '',
    };

    render() {
        if (this.state.error) {
            return <Alert variant="danger">{this.state.error}</Alert>
        }
        return (
            <div>
                <Row className="mx-0">
                    <h2 className="mt-4">Packages</h2>
                    <SearchForm loadPackages={this.loadPackages}/>
                </Row>
                <span>Total: {this.state.total}</span>

                <Table>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Reference/order number</th>
                        <th>Country / LMS</th>
                        <th>Consignee</th>
                        <th>USD</th>
                        <th>Status</th>
                        <th>Created</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.packages.map((p, index) => {
                                const details = `/package/${p.id}/details`;
                                return (
                                    <tr key={index}>
                                        <td><Link to={details}>{p.code}</Link></td>
                                        <td>{p.track}</td>
                                        <td>{p.country_of_destination} / {p.last_mile_service}</td>
                                        <td>{p.consignee_name} {p.consignee_surname}</td>
                                        <td>{p.total_price}</td>
                                        <td>{p.status}</td>
                                        <td>{DateUtils.toLocalDateString(p.created_at)}</td>
                                    </tr>
                                )
                            }
                        )
                    }
                    </tbody>
                </Table>

                <Row>
                    <Col className="col-6">
                        {this.state.previous &&
                        <Button onClick={() => this.loadPackages(this.state.previous)}>&lt; Previous</Button>
                        }
                    </Col>
                    <Col className="col-6 text-right">
                        {this.state.next &&
                        <Button onClick={() => this.loadPackages(this.state.next)}>&gt; Next</Button>
                        }
                    </Col>
                </Row>
            </div>
        )
    }

    componentDidMount() {
        this.loadPackages('/api/v1/package/list');
    }

    loadPackages = url => {
        jwtClient.get(url)
            .then(response => {
                const data = response.data;
                this.setState({
                    packages: data.results,
                    total: data.count,
                    next: data.next,
                    previous: data.previous,
                });
            })
            .catch(() => {
                this.setState({error: 'The service has responded with an error! Contact the administrators to resolve the issue!'});
            })
    }
}
